import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ng6-toastr-notifications';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StickyModule } from 'ng2-sticky-kit';
import { CommonModule, DatePipe } from '@angular/common';
import { LandingModule } from './landing/landing.module';
import { MatMenuModule } from '@angular/material/menu';
import { DashboardModule } from './dashboard/dashboard.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { homeServices } from './home/Services/home.service';
import { LoaderModules } from './loader/loader.module';
import { NgxLoadingModule } from "ngx-loading";
import {  HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from 'src/app/shared/Services/loader-interceptor.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AuthGuard } from './shared/Services/auth.guard';
import { CoreModule } from './core/core.module';
import { PhoneNumberFormatPipe } from './shared/Services/phone-number-format.pipe';



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    MatTabsModule,
    MatMenuModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    NgbModule,
    StickyModule,
    LandingModule,
    CommonModule,
    NgxLoadingModule.forRoot({}),
    LoaderModules,
    BrowserAnimationsModule,
    MatPaginatorModule,
    CoreModule
  ],
  providers: [DatePipe,homeServices,AuthGuard,PhoneNumberFormatPipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true,
  }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
